import { create } from 'zustand';

interface CompleteVulModalStore {
  isOpen: boolean;
  vulId: number;
  planSlug: string;
  onDeleteVulClose: () => void;
  onDeleteVulOpen: (vulId: number, planSlug: string) => void;
}

export const useDeletePlanOnMapModalStore = create<CompleteVulModalStore>(set => ({
  isOpen: false,
  vulId: 0,
  planSlug: '',
  onDeleteVulClose: () => set({ isOpen: false, vulId: 0, planSlug: '' }),
  onDeleteVulOpen: (vulId: number, planSlug: string) => set({ isOpen: true, vulId, planSlug }),
}));
